module.exports = __webpack_public_path__ + "static/media/logo_2.c62863f1.svg";